'use client';

import React from 'react';
import Link from 'next/link';
import { trackEvent } from '@/lib/analytics';

interface CTAPrimaryProps {
  label: string;
  href?: string;
  onClick?: () => void;
  type?: 'button' | 'submit';
  disabled?: boolean;
  className?: string;
}

export default function CTAPrimary({
  label,
  href,
  onClick,
  type = 'button',
  disabled = false,
  className = '',
}: CTAPrimaryProps) {
  const handleClick = () => {
    trackEvent('CTA_click', { cta_label: label });
    onClick?.();
  };

  const baseClasses = `inline-flex items-center justify-center px-6 py-3 text-sm font-semibold text-primary-foreground bg-primary hover:bg-willow-dark transition-colors duration-150 tracking-wide disabled:opacity-50 disabled:cursor-not-allowed ${className}`;

  if (href) {
    return (
      <Link href={href} onClick={handleClick} className={baseClasses}>
        {label}
      </Link>
    );
  }

  return (
    <button
      type={type}
      onClick={handleClick}
      disabled={disabled}
      className={baseClasses}
    >
      {label}
    </button>
  );
}